import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Typography, Grid, Card, CardContent, Button } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { DataGrid } from '@mui/x-data-grid';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import Dialogtransferir from './dialogTransferir';
import Transitotranf from './transitotranf';
import Listtransf from './listtransf';
import {
  BorderColorRounded,
  ContentPasteGoRounded,
  GetAppRounded,
  Search as SearchIcon,
} from '@mui/icons-material';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { PlantillaTransferencia } from './plantillatransferencia';
import { useApi, useSucursales } from 'lib/api';
import { FP, PageHeader, fpDataGridSx, StatusPill } from 'components/financepro';
import { useNavigate } from 'react-router-dom';


const INPUT_SX = {
  '& .MuiOutlinedInput-root': {
    height: 46,
    minHeight: 46,
    borderRadius: 1.6,
    bgcolor: '#FFFFFF',
    '& fieldset': { borderColor: FP.color.border },
    '&:hover fieldset': { borderColor: FP.color.borderStrong },
    '&.Mui-focused fieldset': { borderColor: FP.color.navy },
  },
  '& .MuiInputLabel-root': { fontSize: '0.86rem' },
};

const TABS = [
  {
    key: 0,
    label: 'Creación',
    description: 'Seleccione chasis y arme la transferencia',
    icon: BorderColorRounded,
  },
  {
    key: 1,
    label: 'Recepción',
    description: 'Confirme los chasis recibidos en tránsito',
    icon: GetAppRounded,
  },
  {
    key: 2,
    label: 'Seguimiento',
    description: 'Histórico y estatus de transferencias',
    icon: ContentPasteGoRounded,
  },
];

function StepTab({ active, label, description, icon: Icon, onClick }) {
  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      sx={{
        flex: 1,
        cursor: 'pointer',
        px: { xs: 1.6, md: 2.4 },
        py: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.4,
        bgcolor: active ? '#FFFFFF' : 'transparent',
        borderBottom: active ? `2px solid ${FP.color.navy}` : `2px solid transparent`,
        transition: 'all 0.18s ease',
        '&:hover': {
          bgcolor: active ? '#FFFFFF' : '#F4F6FB',
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 1.4,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: active ? FP.color.navy : FP.color.surfaceAlt,
          color: active ? '#FFFFFF' : FP.color.textSecondary,
          transition: 'all 0.18s ease',
        }}
      >
        <Icon sx={{ fontSize: 22 }} />
      </Box>
      <Box sx={{ minWidth: 0, flex: 1, textAlign: 'left' }}>
        <Typography
          sx={{
            fontWeight: 800,
            color: active ? FP.color.textPrimary : FP.color.textSecondary,
            fontSize: '0.95rem',
            lineHeight: 1.15,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            color: FP.color.textMuted,
            fontSize: '0.72rem',
            fontWeight: 500,
            lineHeight: 1.4,
            display: { xs: 'none', md: 'block' },
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}

function StatTile({ label, value, accent }) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        px: 2,
        py: 1.6,
        borderRadius: 1.6,
        border: `1px solid ${FP.color.border}`,
        bgcolor: '#FAFBFE',
      }}
    >
      <Typography
        sx={{
          color: FP.color.textSecondary,
          fontSize: '0.66rem',
          fontWeight: 700,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          mb: 0.6,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontWeight: 800,
          color: accent || FP.color.textPrimary,
          fontSize: '1.4rem',
          fontVariantNumeric: 'tabular-nums',
          letterSpacing: '-0.02em',
          lineHeight: 1.1,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

function Transferenciaschasis(props) {
  const { post } = useApi();
  const [nosucursal, setNosucursal] = useState('');
  const [rows, setRows] = useState([]);
  const [rowsOriginal, setRowsOriginal] = useState([]);
  const [solochasis, setsolochasis] = useState([]);
  const sucursales = useSucursales();

  const [currentsucursal, setCurrentSucursal] = useState([]);
  const [transferidos, setTransferidos] = useState([]);
  const [open, setOpen] = useState(false);
  const [chasis, setChasis] = useState('');
  const [position, setPosition] = useState(0);
  const [openpantallatransferencia, setOpenpantallatransferencia] = useState(false);
  const navigate = useNavigate();

  const columns = [
    { field: 'Marca', headerName: 'Marca', type: 'string', width: 110 },
    { field: 'Modelo', headerName: 'Modelo', type: 'string', width: 110 },
    { field: 'Color', headerName: 'Color', type: 'string', width: 110 },
    { field: 'Chasis', headerName: 'Chasis', type: 'string', width: 220 },
    {
      field: 'Valor',
      headerName: 'Valor',
      type: 'string',
      width: 110,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: ' ',
      headerName: '',
      width: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => agregartransferidos(params.row)}
          sx={{
            bgcolor: FP.color.navy,
            color: '#FFFFFF',
            borderRadius: 1.2,
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '0.78rem',
            boxShadow: 'none',
            px: 1.6,
            '&:hover': { bgcolor: FP.color.navyDeep, boxShadow: 'none' },
          }}
        >
          Seleccionar
        </Button>
      ),
    },
  ];

  function agregartransferidos(row) {
    const newItems = rows.filter((item) => item !== row);
    setRows(newItems);
    setRowsOriginal(rowsOriginal.filter((item) => item !== row));
    setTransferidos([...transferidos, row]);
  }

  function eliminarTransferido(row) {
    const newItems = transferidos.filter((item) => item !== row);
    setTransferidos(newItems);
    setRows([...rows, row]);
    setRowsOriginal([...rows, row]);
  }

  async function buscarmotores() {
    setTransferidos([]);

    const { status, data } = await post('/api/informemotorestransf', {
      sucursal: currentsucursal.split('-')[0],
    });
    if (status === 200) {
      setRows(data['motor']);
      setsolochasis(data['solochasis']);
      setRowsOriginal(data['motor']);
    }
    if (status === 400) {
      setRows([]);
      alert(data['Error']);
    }
  }

  async function confirm(sucursalTrans, transportista, comentario, setOpen, setOpenpantallatransferencia) {
    const { status, data } = await post('/api/creartransferencia', {
      tipo: 'chasis',
      sucursal: currentsucursal,
      sucursalrecep: sucursalTrans,
      motores: transferidos,
      comentario: comentario === 'comentario' ? '' : comentario,
      transportista: transportista === 'transportista' ? '' : transportista,
    });
    if (status === 200) {
      PlantillaTransferencia(
        sucursalTrans,
        localStorage.getItem('nombrenegocio'),
        transferidos,
        'Chasis transferidos'
      );
      setOpen(false);
      setOpenpantallatransferencia(!openpantallatransferencia);
    }
    if (status === 400) {
      console.log(data['Error']);
    }
  }

  function handlebuscarchasis() {
    const selectedChasis =
      typeof chasis === 'string'
        ? chasis.trim()
        : (chasis?.label || chasis?.value || '').toString().trim();

    if (!selectedChasis) {
      setRows(rowsOriginal);
      return <div></div>;
    }

    const array2 = transferidos.filter((value) => value.Chasis === selectedChasis);
    if (array2.length === 0) {
      const array = rowsOriginal.filter((value) => value.Chasis === selectedChasis);
      if (array.length !== 0) {
        setRows(array);
      } else {
        setRows(rowsOriginal);
      }
    } else {
      setRows(rowsOriginal);
    }

    return <div></div>;
  }

  function closeTransfer() {
    setTransferidos([]);
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box component="main" sx={{ minHeight: '100vh', bgcolor: FP.color.surface }}>
      <PageHeader
        title="Motores"
        subtitle="Transferencia de Chasis"
        cta={
          <StatusPill
            label={`${transferidos.length} chasis seleccionados`}
            variant={transferidos.length > 0 ? 'success' : 'neutral'}
            sx={{ height: 30, fontSize: '0.74rem' }}
          />
        }
      />

      <Box sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
        <Card
          elevation={0}
          sx={{
            mb: 3,
            borderRadius: 2.5,
            border: `1px solid ${FP.color.border}`,
            bgcolor: FP.color.cardBg,
            boxShadow: FP.shadow.soft,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
            {TABS.map((tab) => (
              <StepTab
                key={tab.key}
                active={position === tab.key}
                label={tab.label}
                description={tab.description}
                icon={tab.icon}
                onClick={() => setPosition(tab.key)}
              />
            ))}
          </Box>
        </Card>

        {position === 0 && (
          <>
            {transferidos.length !== 0 ? (
              <Dialogtransferir
                transferidos={transferidos}
                sucursales={sucursales}
                current={currentsucursal}
                eliminarTransferido={eliminarTransferido}
                closeTransfer={closeTransfer}
                confirmar={confirm}
                openpantallatransferencia={!openpantallatransferencia}
                setOpenpantallatransferencia={setOpenpantallatransferencia}
              />
            ) : (
              ''
            )}

            <Card
              elevation={0}
              sx={{
                mb: 3,
                borderRadius: 2.5,
                border: `1px solid ${FP.color.border}`,
                bgcolor: FP.color.cardBg,
                boxShadow: FP.shadow.soft,
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  px: { xs: 2, md: 3 },
                  py: 1.6,
                  borderBottom: `1px solid ${FP.color.border}`,
                  bgcolor: '#FAFBFE',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.2,
                }}
              >
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: 1.2,
                    bgcolor: FP.color.accentBlueSoft,
                    color: FP.color.accentBlue,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <SearchIcon sx={{ fontSize: 18 }} />
                </Box>
                <Typography sx={{ fontWeight: 700, color: FP.color.textPrimary, fontSize: '0.98rem' }}>
                  Seleccionar chasis para transferencia
                </Typography>
              </Box>
              <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                <Grid container spacing={2.5} alignItems="stretch">
                  <Grid item xs={12} md={5}>
                    <Autocomplete
                      disablePortal
                      id="combo-sucursal-transferencia"
                      options={[
                        {
                          label: localStorage.getItem('sucursal'),
                          value: localStorage.getItem('sucursal'),
                        },
                      ]}
                      value={currentsucursal}
                      onChange={(event, value) => setCurrentSucursal(value?.label || '')}
                      getOptionLabel={(opt) => (typeof opt === 'string' ? opt : opt?.label || '')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Sucursal origen"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          sx={INPUT_SX}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} display="flex" alignItems="stretch">
                    <Button
                      variant="contained"
                      startIcon={<SearchIcon />}
                      onClick={() => buscarmotores()}
                      fullWidth
                      sx={{
                        height: 46,
                        bgcolor: FP.color.navy,
                        color: '#FFFFFF',
                        borderRadius: 1.4,
                        textTransform: 'none',
                        fontWeight: 700,
                        boxShadow: 'none',
                        '&:hover': { bgcolor: FP.color.navyDeep, boxShadow: 'none' },
                      }}
                    >
                      Buscar
                    </Button>
                  </Grid>

                  <Grid item xs={12} md={7}>
                    <Autocomplete
                      disablePortal
                      freeSolo
                      id="combo-chasis-transferencia"
                      options={solochasis}
                      value={chasis}
                      onChange={(event, value) => setChasis(value || '')}
                      onInputChange={(event, value) => setChasis(value || '')}
                      getOptionLabel={(opt) =>
                        typeof opt === 'string' ? opt : opt?.label || opt?.value || ''
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Buscar chasis"
                          placeholder="Filtrar por VIN…"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          sx={INPUT_SX}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} display="flex" justifyContent="flex-start">
                    <Button
                      variant="outlined"
                      startIcon={<SearchIcon />}
                      onClick={() => handlebuscarchasis()}
                      sx={{
                        borderColor: FP.color.border,
                        color: FP.color.textPrimary,
                        bgcolor: '#FFFFFF',
                        height: 42,
                        borderRadius: 1.4,
                        textTransform: 'none',
                        fontWeight: 700,
                        '&:hover': {
                          bgcolor: FP.color.surfaceAlt,
                          borderColor: FP.color.borderStrong,
                        },
                      }}
                    >
                      Filtrar chasis
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 2,
                        flexWrap: 'wrap',
                        mb: 2,
                      }}
                    >
                      <StatTile
                        label="Chasis disponibles"
                        value={String(rows.length)}
                        accent={FP.color.accentBlue}
                      />
                      <StatTile
                        label="Seleccionados"
                        value={String(transferidos.length)}
                        accent={FP.color.successDark}
                      />
                      <StatTile
                        label="Total inventario"
                        value={String(rowsOriginal.length || rows.length)}
                        accent={FP.color.navy}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box sx={{ width: '100%', overflowX: 'auto' }}>
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        experimentalFeatures={{ newEditingApi: true }}
                        rowHeight={44}
                        sx={{
                          minWidth: { xs: 720, sm: '100%' },
                          height: 480,
                          ...fpDataGridSx,
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </>
        )}

        {position === 1 && (
          <Card
            elevation={0}
            sx={{
              borderRadius: 2.5,
              border: `1px solid ${FP.color.border}`,
              bgcolor: FP.color.cardBg,
              boxShadow: FP.shadow.soft,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                px: { xs: 2, md: 3 },
                py: 1.6,
                borderBottom: `1px solid ${FP.color.border}`,
                bgcolor: '#FAFBFE',
                display: 'flex',
                alignItems: 'center',
                gap: 1.2,
              }}
            >
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: 1.2,
                  bgcolor: FP.color.warningSoft,
                  color: FP.color.warning,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <LocalShippingRoundedIcon sx={{ fontSize: 18 }} />
              </Box>
              <Typography sx={{ fontWeight: 700, color: FP.color.textPrimary, fontSize: '0.98rem' }}>
                Recepción de chasis en tránsito
              </Typography>
            </Box>
            <CardContent sx={{ p: { xs: 1, md: 2 } }}>
              <Transitotranf tipo={'chasis'} />
            </CardContent>
          </Card>
        )}

        {position === 2 && (
          <Card
            elevation={0}
            sx={{
              borderRadius: 2.5,
              border: `1px solid ${FP.color.border}`,
              bgcolor: FP.color.cardBg,
              boxShadow: FP.shadow.soft,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                px: { xs: 2, md: 3 },
                py: 1.6,
                borderBottom: `1px solid ${FP.color.border}`,
                bgcolor: '#FAFBFE',
                display: 'flex',
                alignItems: 'center',
                gap: 1.2,
              }}
            >
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: 1.2,
                  bgcolor: FP.color.successSoft,
                  color: FP.color.successDark,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CheckCircleRoundedIcon sx={{ fontSize: 18 }} />
              </Box>
              <Typography sx={{ fontWeight: 700, color: FP.color.textPrimary, fontSize: '0.98rem' }}>
                Seguimiento de transferencias
              </Typography>
            </Box>
            <CardContent sx={{ p: { xs: 1, md: 2 } }}>
              <Listtransf sucursales={sucursales} tipo={'chasis'} />
            </CardContent>
          </Card>
        )}

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{ sx: { borderRadius: 2 } }}
        >
          <DialogTitle id="alert-dialog-title">{'Eliminacion Registro'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Desea Eliminar este registro de Incauto?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button style={{ color: 'white' }} onClick={handleClose} autoFocus>
              NO
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}
export default Transferenciaschasis;
